import {
    $isElementNode,
    EditorConfig, ElementNode, RangeSelection, SerializedElementNode,
    Spread
} from "lexical"
import {$createBadgeNode, BadgeType} from "../badge-plugin"
import {NodeKey} from "lexical/LexicalNode"
import {addClassNamesToElement} from "@lexical/utils"
import {lexicalGetColorNumber} from "../../../../actions/ge-color-number"

export type SerializedBadgeNode = Spread<
    {
        badgeType: BadgeType
    },
    SerializedElementNode
>

export class BadgeNode extends ElementNode {

    __badgeType: BadgeType

    constructor(badgeType: BadgeType, key?: NodeKey) {
        super(key)

        this.__badgeType = badgeType
    }

    static getType(): string {
        return 'badge-node' // just unique string
    }

    static clone(node: BadgeNode): BadgeNode {
        return new BadgeNode(node.__badgeType, node.__key)
    }

    static importJSON(serializedNode: SerializedBadgeNode): BadgeNode {
        return $createBadgeNode(serializedNode.badgeType)
    }

    setType(value:BadgeType) {
        // getWritable() creates a clone of the node
        // if needed, to ensure we don't try and mutate
        // a stale version of this node.
        const self = this.getWritable()
        self.__badgeType = value
    }

    getType() {
        const self = this.getLatest()
        return self.__badgeType
    }

    exportJSON() {
        return {
            ...super.exportJSON(),
            type        : BadgeNode.getType(),
            badgeType   : this.__badgeType
        }
    }

    createDOM(config: EditorConfig): HTMLElement {
        const element = document.createElement('span');
        addClassNamesToElement(element, config.theme.badge, getBadgeTypeClass(this.__badgeType))
        return element
    }

    updateDOM(prevNode: BadgeNode, dom: HTMLElement, config: EditorConfig): boolean {
        return false;
    }

    insertNewAfter(
        selection: RangeSelection,
        restoreSelection = true,
    ): null | ElementNode {
        const element = this.getParentOrThrow().insertNewAfter(
            selection,
            restoreSelection,
        );
        if ($isElementNode(element)) {
            const linkNode = $createBadgeNode(this.__badgeType)
            element.append(linkNode)
            return linkNode
        }
        return null
    }

    canInsertTextBefore(): false {
        return false;
    }

    canInsertTextAfter(): false {
        return false;
    }

    canBeEmpty(): false {
        return false;
    }

    isInline(): true {
        return true;
    }

    /*extractWithChild(
        child: LexicalNode,
        selection: RangeSelection | NodeSelection | GridSelection,
        destination: 'clone' | 'html',
    ): boolean {
        if (!$isRangeSelection(selection)) {
            return false
        }

        const anchorNode = selection.anchor.getNode()
        const focusNode = selection.focus.getNode()

        return (
            this.isParentOf(anchorNode) &&
            this.isParentOf(focusNode) &&
            selection.getTextContent().length > 0
        )
    }*/
}

function getBadgeTypeClass(badgeType: BadgeType) {
    return 'bg-project-paleBg-{0}'.f(lexicalGetColorNumber(badgeType))
}